import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface RejectLeaveModalProps {
  show: boolean;
  reason: string;
  submitting?: boolean;
  onChangeReason: (value: string) => void;
  onHide: () => void;
  onConfirm: () => void;
}

const RejectLeaveModal: React.FC<RejectLeaveModalProps> = ({
  show,
  reason,
  submitting = false,
  onChangeReason,
  onHide,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Reject Leave Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Reason for Rejection</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={reason}
            onChange={(e) => onChangeReason(e.target.value)}
            placeholder="Please provide a reason for rejecting this leave request"
            required
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={submitting || !reason.trim()}
        >
          {submitting ? "Rejecting..." : "Confirm Rejection"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectLeaveModal;
